import classes from './Pannelheader.module.css'

const PannelHeader = ({children, padding, mode}) => {
    return <div className={`${classes.pannel_header} ${padding ? classes[padding] : ''} ${mode ? classes['mode_' + mode] : ''}`}>
        {children}        
    </div>
}

export default PannelHeader